const FALLBACK_LABEL = 'Working on your request'

const LABEL_MAP = {
  'Content specialists working': 'Creating content',
  'Data verification': 'Reading uploaded file',
  'Document assembly': 'Creating content',
  'Final packaging': 'Preparing final file',
  'Finished a step': 'Final quality check',
  'Strategy in progress': 'Planning deliverable',
  'Working...': FALLBACK_LABEL,
}

const INTERNAL_WORDS = ['mcp_', 'do-chat', 'stage_document', 'sandbox', 'api', '/app/', '/data/']

function mappedLabel(label) {
  const text = String(label ?? '').trim()
  if (!text) return FALLBACK_LABEL
  const direct = LABEL_MAP[text]
  if (direct) return direct
  const prefix = Object.keys(LABEL_MAP).find((key) => text.startsWith(`${key}:`))
  return prefix ? LABEL_MAP[prefix] : text
}

function isInternalLabel(label) {
  const text = String(label ?? '').toLowerCase()
  if (INTERNAL_WORDS.some((word) => text.includes(word))) return true
  if (/\bused\s+\d+\s+tools?\b/i.test(text)) return true
  return /\b[a-z]+_[a-z0-9_]{2,}\b/i.test(text)
}

export function normalizeActivityLabel(label) {
  const labelText = mappedLabel(label)
  return isInternalLabel(labelText) ? FALLBACK_LABEL : labelText
}
